import React from 'react'
import "./home.css";
import Me from"../../assests/niks.png";
import HeaderSocials from './HeaderSocials';
import ScrollDown from './ScrollDown';

const Home = () => {
  return (
    <section className="home container" id="home">
      <div className='intro'>
        <img src={Me} alt="" width="108px" height="108px" className='home__img'/>
        <h1 className='home__name'>Nikhil Kumar</h1>
        <span className='home__education'>I'm a Competitive Programmer.
        </span>

        <HeaderSocials/>

        <a href="#contact" className="btn">Hire Me</a>
        <ScrollDown/>
      </div>
    </section>
  )
}

export default Home